import { SettingsTabItem } from './SettingsTabItem';

type SettingsTabBarProps<T extends string> = {
  tabs: SettingsTabItem<T>[];
  activeTab: T;
  onChange: (tabId: T) => void;
};

export function SettingsTabBar<T extends string>({
  tabs,
  activeTab,
  onChange,
}: SettingsTabBarProps<T>) {
  return (
    <div className="erp-tab-bar" role="tablist" aria-label="Seções de configuração">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`erp-tab ${isActive ? 'erp-tab--active' : 'erp-tab--inactive'}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
